import { authFetch, BASE_BACKEND_URL } from '../../auth'
import {
  DAILY_SETTLEMENT_ERROR_MESSAGES,
  DAILY_SETTLEMENT_HTTP_ERROR_MESSAGES,
  DAILY_SETTLEMENT_ERROR_DEFAULT
} from './constants/dailySettlementErrorConstants'

export async function dailyControlRequest(params, { endpoint = '', signal } = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value != null && value !== '')
  )
  const response = await authFetch(
    `${BASE_BACKEND_URL}/settlement_daily_controls${endpoint}?${query}`,
    { signal }
  )
  if (!response?.ok) {
    const body = await response?.json().catch(() => ({}))
    const message =
      DAILY_SETTLEMENT_ERROR_MESSAGES[body?.error] ||
      (typeof body?.message === 'string' && body.message) ||
      DAILY_SETTLEMENT_HTTP_ERROR_MESSAGES[response?.status] ||
      DAILY_SETTLEMENT_ERROR_DEFAULT
    const error = new Error(message)
    error.code = body?.error
    error.status = response?.status
    throw error
  }
  return response.json()
}
